import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowDown, FiCheckCircle } = FiIcons;

function Hero() {
  const scrollToPrograms = () => {
    document.getElementById('programs')?.scrollIntoView({
      behavior: 'smooth',
    });
  };

  return (
    <header className="hero">
      <div className="hero-overlay" />
      <div className="hero-content">
        <p className="eyebrow">Dallas HVAC Training Directory</p>
        <h1
          style={{
            fontSize: '40px',
            display: 'block',
            width: '100%',
            textAlign: 'center',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          Compare HVAC Schools in Dallas
        </h1>
        <p className="hero-copy">
          Build the technical knowledge and hands-on confidence needed for a
          career maintaining the systems that keep Dallas homes, businesses,
          hospitals, and industrial facilities comfortable.
        </p>
        <button className="primary-button" onClick={scrollToPrograms}>
          Explore Dallas HVAC Programs
          <SafeIcon icon={FiArrowDown} aria-hidden="true" />
        </button>
        <p className="trust-line">
          <SafeIcon icon={FiCheckCircle} aria-hidden="true" />
          Independent comparisons covering formats, credentials, skills, and
          career-readiness details
        </p>
      </div>
    </header>
  );
}

export default Hero;